import axios from "axios";
import { OutputBaseProps } from "utils/types/API";

export interface UserStatistical {
    count: number;
    createdToday: number;
    createdThisMonth: number;
    roles: Array<{ name: string; count: number }>;
}
type ApiUserStatisticalOutputProps = OutputBaseProps<UserStatistical>;

export const apiUserStatistical = async () => {
    const res = (await axios.get<ApiUserStatisticalOutputProps>("/api/statistical/user"))
        .data;
    return res;
};